import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  findCarteBySocieteApi,
  ListCartes,
} from "../../../_App/Redux/Slices/cartes/carteSlice";
import {
  findCategorieBySocieteApi,
  ListCategories,
} from "../../../_App/Redux/Slices/categories/categorieSlice";
import {
  findSousCategorieBySociete,
  ListSousCategories,
} from "../../../_App/Redux/Slices/souscategories/souscategorieSlice";
import {
  findProductsCaracteristiquesApiBySociete,
  ListProductCaracteristiques,
} from "../../../_App/Redux/Slices/product_caracteristique/product_caracteristiqueSlice";
import Select from "react-select";
import { ListNumberPagecentaines, ListNumberPageDixièmes } from "../../../_App/Data/ListNumberPage";
export default function RemiseFilter({
  t,
  societeid,
  setFiltre,
  Filtre,
  searchfiltre,
  selections,
  setSelections,
}: any) {
  const dispatch = useAppDispatch();
  const cartes = useAppSelector(ListCartes);
  const categories = useAppSelector(ListCategories);
  const souscategories = useAppSelector(ListSousCategories);
  const carateristique = useAppSelector(ListProductCaracteristiques);

  const [categoriesOptions, setcategoriesdOptions] = useState<any[]>([]);

  const CartesOptions = cartes?.map((option) => ({
    value: option._id,
    label: option.libelle.fr,
  }));
  const souscategoriesOptions = souscategories?.map((option) => ({
    value: option._id,
    label: option.libelle.fr,
  }));
  useEffect(() => {
    if (societeid) {
      const fetchData = async () => {
        await dispatch(findCarteBySocieteApi(societeid));
        await dispatch(findCategorieBySocieteApi(societeid));
        await dispatch(findSousCategorieBySociete(societeid));
        await dispatch(findProductsCaracteristiquesApiBySociete(societeid));
      };
      fetchData();
    }
  }, [societeid]);

  useEffect(() => {
    if (Filtre && Filtre.carte && Filtre.carte?.length !== 0) {
      const listcategoriescarte = categories?.filter((item: any) =>
        Filtre.carte?.includes(item.carte_id)
      );
      setcategoriesdOptions(
        listcategoriescarte?.map((option) => ({
          value: option._id,
          label: option.libelle.fr,
        }))
      );
    }
  }, [Filtre]);

  const handleSelectChangeCartes = (selectedOption: any) => {
    const cartes = selectedOption.map((item: any) => item.value);
    setFiltre((prev: any) => ({
      ...prev,
      carte: cartes,
    }));
  };
  const handleSelectChangeCategories = (selectedOption: any) => {
    const categorie = selectedOption.map((item: any) => item.value);
    setFiltre((prev: any) => ({
      ...prev,
      categories: categorie,
    }));
  };
  const handleSelectChangeSousCategories = (selectedOption: any) => {
    const souscategorie = selectedOption.map((item: any) => item.value);
    setFiltre((prev: any) => ({
      ...prev,
      sousCategories: souscategorie,
    }));
  };
  const handleSelectcarateristique = (newSelectedOptions: any, item: any) => {
    setSelections({
      ...selections,
      [item._id]: newSelectedOptions,
    });
  };
  return (
    <div>
      <div className="  bg-white" style={{ padding: "10px" }}>
        <div className="row">
          {CartesOptions?.length !== 0 && (
            <div className="col-3">
              <div className="form-group">
                <label htmlFor="carte">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Carte")}
                </label>
                <Select
                  isMulti
                  options={CartesOptions}
                  isSearchable={true}
                  onChange={handleSelectChangeCartes}
                  value={Filtre?.carte?.map((item: any) =>
                    CartesOptions?.find((cat: any) => cat.value === item)
                  )}
                />
              </div>
            </div>
          )}
          {categoriesOptions?.length !== 0 && (
            <div className="col-3">
              <div className="form-group">
                <label htmlFor="categorie">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Categorie")}
                </label>
                <Select
                  isMulti
                  options={categoriesOptions}
                  isSearchable={true}
                  onChange={handleSelectChangeCategories}
                  value={Filtre.categories?.map((item: any) =>
                    categoriesOptions?.find((cat: any) => cat.value === item)
                  )}
                />
              </div>
            </div>
          )}
          {souscategoriesOptions?.length !== 0 && (
            <div className="col-3">
              <div className="form-group">
                <label htmlFor="sous">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("sous categorie")}
                </label>
                <Select
                  isMulti
                  options={souscategoriesOptions}
                  isSearchable={true}
                  onChange={handleSelectChangeSousCategories}
                  value={Filtre?.sousCategories?.map((item: any) =>
                    souscategoriesOptions?.find(
                      (cat: any) => cat.value === item
                    )
                  )}
                />
              </div>
            </div>
          )}

          {carateristique &&
            carateristique.map((item, index) => (
              <div className="col-3" key={index}>
                <label htmlFor="sous">
                  <span style={{ color: "red" }}></span>
                  {item?.libelle}
                </label>

                <Select
                  isMulti
                  options={
                    item.valeurs &&
                    item.valeurs?.map((v: any) => ({
                      value: { caracteristique_id: item._id, value: v },
                      label: typeof v === "string" ? v : v?.libelle,
                    }))
                  }
                  isSearchable={true}
                  onChange={(newSelectedOptions) =>
                    handleSelectcarateristique(newSelectedOptions, item)
                  }
                />
              </div>
            ))}
        </div>
        <div className="row">
          <div className="col-5 ">
            <div className="form-group ">
              <label htmlFor="carte">
                {" "}
                <span style={{ color: "red" }}></span>
                {t("Intervale reference")}
              </label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="text"
                    className="w-100 form-control product-search br-30"
                    id="input-search"
                    placeholder={t("ref 1")}
                    onChange={(e) =>
                      setFiltre((prev: any) => ({
                        ...prev,
                        ref1: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    className="w-100 form-control product-search br-30"
                    id="input-search"
                    placeholder={t("ref 2")}
                    onChange={(e) =>
                      setFiltre((prev: any) => ({
                        ...prev,
                        ref2: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-5 ">
            <div className="form-group ">
              <label htmlFor="carte">
                {" "}
                <span style={{ color: "red" }}></span>
                {t("Intervale prix")}
              </label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="number"
                    className="w-100 form-control product-search br-30"
                    id="input-search"
                    placeholder={t("prix 1")}
                    onChange={(e) =>
                      setFiltre((prev: any) => ({
                        ...prev,
                        prix1: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    className="w-100 form-control product-search br-30"
                    id="input-search"
                    placeholder={t("prix 2")}
                    onChange={(e) =>
                      setFiltre((prev: any) => ({
                        ...prev,
                        prix2: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-1">
            <label> {"N des lignes"}</label>
            <select 
              onChange={(e) =>
                setFiltre((prev: any) => ({
                  ...prev,
                  NLigne: parseInt(e.target.value),
                }))}
                value={Filtre?.NLigne||100}
            className="w-100 form-control product-search br-30">
              {ListNumberPagecentaines.map((a) => (
                <option key={a} value={a}>
                  {a}
                </option>
              ))}
            </select>
          </div>
          <div
            className="col-1 mt-4"
            style={{ fontSize: "30px" }}
            onClick={searchfiltre}
          >
            {" "}
            <i className="fas fa-search"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
